var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClSemplice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 167,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 83.249,
    cy: 83.041,
    rx: 73.053,
    ry: 72.948
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#FFF",
    strokeWidth: 5,
    cx: 83.62,
    cy: 83.5,
    rx: 81.12,
    ry: 81
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59 52)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 13.864c-6.297 0-12.524 2.523-16.977 6.896C2.57 25.134 0 31.248 0 37.432c0 6.184 2.57 12.231 7.023 16.605C11.477 58.41 17.703 61 24 61c6.297 0 12.524-2.59 16.977-6.963C45.431 49.663 48 43.617 48 37.432c0-6.184-2.57-12.299-7.023-16.672-4.454-4.37-10.68-6.896-16.977-6.896zm0 2.142c5.697 0 11.381 2.271 15.409 6.227 4.028 3.956 6.409 9.604 6.409 15.199 0 5.595-2.381 11.176-6.41 15.131-4.027 3.956-9.71 6.294-15.408 6.294-5.697 0-11.381-2.338-15.409-6.294-4.028-3.955-6.409-9.534-6.409-15.131 0-5.595 2.381-11.243 6.41-15.199 4.027-3.956 9.71-6.227 15.408-6.227z",
    fill: "#FCBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.789 25.93c-.394.146-.655.572-.634 1.04v6.172c-.005.278.092.546.265.746.173.197.41.309.657.309a.875.875 0 0 0 .657-.31c.173-.2.27-.467.265-.745V26.97a1.09 1.09 0 0 0-.362-.878.842.842 0 0 0-.848-.161z",
    fill: "#FCBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.538 32.348c-2.26 0-4.153 1.895-4.153 4.16 0 2.264 1.892 4.159 4.153 4.159 2.262 0 4.154-1.895 4.154-4.16 0-2.264-1.892-4.159-4.154-4.159zm0 2.08c1.003 0 2.077 1.076 2.077 2.08 0 1.003-1.074 2.08-2.077 2.08-1.002 0-2.076-1.077-2.076-2.08 0-1.004 1.074-2.08 2.076-2.08zM23.077 0c-3.953 0-7.385 3.435-7.385 7.394 0 3.958 3.431 7.394 7.385 7.394 3.954 0 7.385-3.435 7.385-7.394C30.462 3.436 27.03 0 23.077 0zm0 2.112c2.674 0 5.274 2.604 5.274 5.282 0 2.677-2.6 5.28-5.274 5.28s-5.275-2.603-5.275-5.28c0-2.678 2.6-5.282 5.275-5.282z",
    fill: "#F3B706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 19.41c-9.274 0-17.538 8.274-17.538 17.56 0 9.285 8.264 17.56 17.538 17.56 9.274 0 17.538-8.275 17.538-17.56 0-9.286-8.264-17.56-17.538-17.56zm0 2.194c7.944 0 15.346 7.411 15.346 15.366 0 7.954-7.402 15.365-15.346 15.365S8.654 44.924 8.654 36.97c0-7.955 7.402-15.366 15.346-15.366z",
    fill: "#FCBB00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3B706",
    d: "M22.1538462 9.24242424L22.1538462 15.7121212 24 15.7121212 24 9.24242424z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3B706",
    d: "M21.2307692 6.46969697L21.2307692 8.31818182 25.8461538 8.31818182 25.8461538 6.46969697z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3B706",
    d: "M40.2620114 13.8636364L38.7692308 15.2932532 45.5841424 22.1818182 47.0769231 20.6871886z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.484 35.174c-.465.14-.784.525-.79.965-.186 2.036-.902 4.008-2.082 5.656a.942.942 0 0 0-.207.805c.057.28.244.527.517.681.27.152.6.198.91.123.308-.074.57-.262.719-.516a13.485 13.485 0 0 0 2.441-6.621c.046-.35-.112-.694-.42-.918a1.26 1.26 0 0 0-1.088-.175zm-4.022 9.19a.926.926 0 0 0 .923.924.923.923 0 1 0-.923-.924z",
    fill: "#F3B706"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClSemplice);
export default __webpack_public_path__ + "static/media/cl_semplice.b84a8bfc5bba6e1f9362470907492a3d.svg";
export { ForwardRef as ReactComponent };